import { extend } from "../ExtensionProvider";
import * as React from "react";
function ExtensibleControl(props) {
    const { objects, wrapperProps } = props;
    const wrappers = objects.sort((lhs, rhs) => rhs.priority - lhs.priority);
    let cur = React.createElement(React.Fragment, null, props.children);
    for (const wrapper of wrappers) {
        cur = React.createElement(wrapper.wrapper, { ...(wrapperProps ?? {}) }, cur);
    }
    return cur;
}
function registerControlWrapper(instanceGroup, group, priority, wrapper) {
    if (instanceGroup === group) {
        return { priority, wrapper };
    }
}
export default extend(registerControlWrapper, "group")(ExtensibleControl);
